export default __webpack_public_path__ + "static/media/Home main@2x.16192c2c.png";